// extracted by css-extract-rspack-plugin
export default {"NativeQueryEditorContainer":"l6Gxf"};